type IVRequirementParams = {
  isIVEnabled?: boolean;
  isBiometricMatchForAll?: boolean;
  isLeaderGuest?: boolean;
};

type IVRegistrationGateParams = IVRequirementParams & {
  isGuestRegisterBlocked?: boolean;
};

type IVSkipParams = IVRegistrationGateParams & {
  isDataLoaded?: boolean;
  isIVOnProperty?: boolean;
};

function isIVRequiredForGuest({
  isIVEnabled,
  isBiometricMatchForAll,
  isLeaderGuest,
}: IVRequirementParams): boolean {
  if (!isIVEnabled) {
    return false;
  }

  return Boolean(isBiometricMatchForAll) || isLeaderGuest !== false;
}

function isRegisterBlockedWithoutIV({
  isGuestRegisterBlocked,
  ...requirement
}: IVRegistrationGateParams): boolean {
  return Boolean(isGuestRegisterBlocked) && isIVRequiredForGuest(requirement);
}

/**
 * Whether the property's own rules leave the guest free to put identity
 * verification off. Reaching the screen they would land on is a separate
 * question: the guest SDK also checks that the config allows the guest form.
 */
function canSkipIV({isDataLoaded, isIVOnProperty, ...gate}: IVSkipParams): boolean {
  if (!isDataLoaded || isIVOnProperty) {
    return false;
  }

  return !isRegisterBlockedWithoutIV(gate);
}

export {isIVRequiredForGuest, isRegisterBlockedWithoutIV, canSkipIV};
export type {IVRequirementParams, IVRegistrationGateParams, IVSkipParams};
